import { render, staticRenderFns } from "./setGame11.vue?vue&type=template&id=d23223ba&"
import script from "./setGame11.vue?vue&type=script&lang=js&"
export * from "./setGame11.vue?vue&type=script&lang=js&"
import style0 from "./setGame11.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports